import {
  crearQueryParamHistorial,
  FiltrosHistorial,
  HHMMaMinutos,
  RegistroHistórico,
  RegistroHistorialAPI,
  TipoReclamo,
  XOR,
} from "src/utils";
import api from "src/services/api";

const Historial = {
  async registrosDelHistorial(filtros: FiltrosHistorial) {
    const registros: RegistroHistórico[] = [];

    const link = XOR(filtros.soloHorasProcesadas, filtros.soloHorasSinProcesar)
      ? filtros.soloHorasProcesadas
        ? "horas/procesadas"
        : "horas/pendientes"
      : "horas/todos";

    // por defecto
    const ocultarPendientes = link === "horas/todos";

    const params = crearQueryParamHistorial(filtros);

    await api.get(`${link}${params}`).then(
      (response) => {
        const historial = response.data.datos;

        historial.forEach((registro: RegistroHistorialAPI) => {
          if (ocultarPendientes && registro.tipo === "SIN-A") return;

          registros.push({
            id: registro.id,
            codigoPuntoServicio: registro.ps_codigo,
            nombrePuntoServicio: registro.ps_nombre,
            horaEntrada: HHMMaMinutos(registro.hora_entrada),
            horaSalida: HHMMaMinutos(registro.hora_salida),
            tiempoTrabajado:
              registro.tipo !== "SIN-A" ? HHMMaMinutos(registro.total) : 0,
            fecha: new Date(registro.fecha),
            tipo: registro.tipo,
            cod_hora: registro.cod_hora,
          });
        });
      },
      (error) => error
    );

    return registros;
  },

  async marcacion(marcacion: number, tipo: TipoReclamo) {
    const link =
      tipo === "procesada"
        ? `horas/procesadas/detalles/${marcacion}`
        : `horas/pendientes/detalles/${marcacion}`;

    return api.get(link).then(
      (response) => {
        const registro: RegistroHistorialAPI = response.data.datos[0];

        return {
          id: registro.id,
          puntoServicio: {
            codigo: registro.ps_codigo,
            nombre: registro.ps_nombre,
          },
          horaEntrada: HHMMaMinutos(registro.hora_entrada),
          horaSalida: HHMMaMinutos(registro.hora_salida),
          fecha: new Date(registro.fecha),
        };
      },
      (error) => error
    );
  },
};

export default Historial;
